<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"
        >{{ $t("messages.titTblServiceOpenStatus") }}
      </span>
    </div>
    <div class="ly-flex">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">{{ listCount }}</span
            >{{ $t("messages.unit") }}
          </p>
          <div class="sort-select">
            <el-select
              size="medium"
              v-model="count"
              :placeholder="$t('messages.plCount25')"
            >
              <el-option
                v-for="item in countList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span>
              {{ $t("messages.perShow") }}
            </span>
          </div>
        </div>
      </div>
      <div class="ly-btn">
        <el-button plain size="small" type="excel"
          >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
        ></el-button>
      </div>
    </div>
    2312321
    <div class="table-body">
      <idc-list :tableData="tableData" :tableHeader="tableHeader">
        <template>
          <el-button type="save" size="small" @click="openWorkDetail">
            <!-- 22.03.15 작업상세화면 모달 이벤트 추가 -->
            {{ $t("messages.btnView") }}
          </el-button>
        </template>
      </idc-list>
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";

export default {
  props: {
    custId: {
      default: "",
    },
  },
  components: {
    IdcList,
  },
  data() {
    return {
      // 22.03.15 count, countList 추가
      count: "25개",
      countList: [
        {
          label: "25개",
          value: "10",
        },
      ],
      tableHeader: [
        {
          prop: "idcCdNm",
          label: "IDC",
          width: "20",
        },
        {
          prop: "svcContId",
          label: "서비스계약ID",
          width: "15",
        },
        {
          prop: "billContId",
          label: "청구계약ID",
          width: "15",
        },
        {
          prop: "svcNo",
          label: "서비스번호",
          width: "20",
        },
        {
          prop: "opnDt",
          label: "개통일시",
          width: "10",
        },
        {
          prop: "ohYmd",
          label: "개통희망일",
          width: "10",
        },
        {
          prop: "contExpPamDay",
          label: "계약만료예정일",
          width: "10",
        },
        
      ],
      tableData: [
      ],
    };
  },
  computed: {
    listCount() {
      return this.tableData.length;
    },
  },
  created() {},
  mounted() {
    this.getSvcContList();
  },
  methods: {
    // 22.03.15 작업상세화면 모달 이벤트 추가
    openWorkDetail() {
      this.$emit("openWorkDetail");
    },

    // 22.03.15 skyttokky : 프로그램 데이터 적용
    getSvcContList() {
      console.log(this.custId);
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Cus.getSvcContList, {
          custId: this.custId,
          paging: false,
        })
        .then((res) => {
          console.log(res);

          if (res.data !== "") {
            this.tableData = res.data.resData.list;
          } else {
            this.tableData = [];
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
  },

  rowClick() {
    // row에 실행워크플로우 아이디 필수
    this.$emit("openWorkDetail", "SVC_20220530_022");
  },
};
</script>

<style></style>
